<template>
  <p
    ref="textElement"
    class="text-grays-600 text-base font-regular truncate truncate-2-rows"
  >
    {{ displayDescription }}
  </p>
</template>

<script>
import ButtonText from "@/components/Global/ButtonText.vue";

export default {
  name: "product-gallery-description",
  props: {
    product: Object,
  },
  components: { ButtonText },
  emits: ["show-more-clicked"],
  data() {
    return {
      isDescriptionOverflowing: false,
    };
  },
  computed: {
    // Fall back to the parent product description when the item has none.
    displayDescription() {
      const own = this.product?.description;
      if (typeof own === "string" && own.trim()) return own;
      const parent = this.product?.product?.description;
      return typeof parent === "string" && parent.trim() ? parent : "";
    },
    hasNutritionalValues() {
      if (!this.product?.product?.barcodes?.length) {
        return false;
      }
      return this.product.product.barcodes.some(
        (barcode) =>
          barcode.nutritional_values && barcode.nutritional_values.length > 0
      );
    },
    hasMetadata() {
      const metadata = this.product?.product?.metadata;
      if (!metadata) return false;

      if (metadata.precautionary_statement?.trim()) return true;
      if (metadata.storage_instructions?.trim()) return true;

      if (metadata.product_components) {
        try {
          const parsed =
            typeof metadata.product_components === "string"
              ? JSON.parse(metadata.product_components)
              : metadata.product_components;

          if (parsed?.Ingredient_Sequence_and_Name?.trim()) return true;

          const listFields = [
            "Allergen_Displayed",
            "Allergen_Type_Code_and_Containment",
            "Allergen_Type_Code_and_Containment_May_Contain",
          ];
          for (const field of listFields) {
            if (parsed?.[field]?.some((item) => item.value?.trim()))
              return true;
          }
        } catch (e) {
          // ignore parse errors
        }
      }

      return false;
    },
  },
  methods: {
    updateShowMoreVisibility() {
      this.$nextTick(() => {
        const textElement = this.$refs.textElement;
        if (textElement) {
          const lineHeight = parseInt(getComputedStyle(textElement).lineHeight);
          const maxLines = 2;
          this.isDescriptionOverflowing =
            textElement.scrollHeight > lineHeight * maxLines;
        }
      });
    },
    handleShowMore() {
      this.$emit("show-more-clicked");
    },
  },
  mounted() {
    this.updateShowMoreVisibility();
  },
};
</script>

<style>
</style>